<div class="summary" appConfigSettingsParagraph>
  <div class="summary-header">
    <h2 appConfigSettingsSecondTitle>{{'ApplicationPage.ClosingStatement' | translate}}</h2>
  </div>
  <div class="summary-statements">
    <div class="summary-statements-title">
      {{'ClosingStatement.WhoDeclare_GG' | translate}}
    </div>
    <div class="summary-statements-bullets">
      <ul>
        <li class="SummaryBullets">{{'ClosingStatement.Bullet1_GG' | translate}}</li>
        <li class="SummaryBullets">{{'ClosingStatement.Bullet2_GG' | translate}}</li>
        <li class="SummaryBullets">
            <div>
                {{'ClosingStatement.Bullet3_GG.0' | translate }}
                <a target="_blank" href="https://www.taf.nl/algemeen/privacy-statement">
                    {{'ClosingStatement.Bullet3_GG.1' | translate }}
                </a>
                {{'ClosingStatement.Bullet3_GG.2' | translate }}
            </div>
        </li>
        <li class="SummaryBullets">{{'ClosingStatement.Bullet4_GG' | translate}}</li>
        <li class="SummaryBullets">{{'ClosingStatement.Bullet5_GG' | translate}}</li>
        <li class="SummaryBullets" [innerHTML]="parseTemplatedStatement('ClosingStatement.Bullet6_GG', 'policy_terms')"></li>
        <li class="SummaryBullets">{{parseTemplatedStatement('ClosingStatement.Bullet7_GG', 'name_intermediary')}}</li>
        <li class="SummaryBullets" *ngIf="getTextFor8Paragraph()">{{getTextFor8Paragraph()}}</li>
        <li class="SummaryBullets" *ngIf="getTextForFinalStatementAddition()" [innerHTML]="getTextForFinalStatementAddition()"></li>
      </ul>
      <div class="buttons-wrapper buttons-wrapper-vertical">
        <div>
          <app-checkbox-input
            placeholder="ClosingStatement.CheckBox"
            [form]="formGroup"
            [control]="formGroup.get('isAgreed')"
          ></app-checkbox-input>
          <app-notification-block
            class="summary-notification-block"
            [notification]="notificationEvent"
          ></app-notification-block>
        </div>
        <div class="buttons-row">
          <app-back-button
            [stepper]="stepper"
          ></app-back-button>
          <button
            class="primary submitApplicationBtn"
            (click)="submitApplication()"
            [disabled]="false"
            [style.color]="formGroup.get('isAgreed').value ? configSettings.backgroundColor : configSettings.backgroundTextColor"
            [style.background]="formGroup.get('isAgreed').value ? configSettings.backgroundTextColor : configSettings.backgroundColor"
            [style.border]="formGroup.get('isAgreed').value ? 'none' : 'solid 1px ' + configSettings.backgroundTextColor"
          >
            {{'ApplicationPage.Apply' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="summary-premium-block">
    <app-premium-block
      [isMobile]="true"
      [isStatementsAgreed]="formGroup.get('isAgreed').value"
      (submitEvent)="submitApplication()"
      [showProductDetails]="true"
      [showControlsBlock]="true"
      [checkIsPremiumsCalculated]="this.getShowQuote"
      [productType]="productType"
      (downloadQuote)="handleDownloadQuote()"
    ></app-premium-block>
  </div>
</div>
